// Общие стили редактора тестов. Заполняют его не технические люди, поэтому
// шрифты крупнее обычного админского, кнопки — со словами вместо иконок,
// а подсказки идут прямо под полем, а не в тултипах.

export const input = {
  width: '100%',
  padding: '11px 12px',
  border: '1px solid #CBD5E1',
  borderRadius: '8px',
  fontFamily: 'inherit',
  fontSize: '15px',
  color: '#0F172A',
  background: '#fff',
};

export const label = {
  fontSize: '13px',
  fontWeight: 600,
  color: '#334155',
  display: 'block',
  marginBottom: '6px',
};

export const hint = {
  fontSize: '12px',
  color: '#94A3B8',
  margin: '6px 0 0',
  lineHeight: 1.5,
};

export const button = {
  padding: '9px 16px',
  borderRadius: '8px',
  border: '1px solid #CBD5E1',
  background: '#fff',
  color: '#334155',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 600,
  fontFamily: 'inherit',
};

export const primaryButton = {
  ...button,
  border: 'none',
  background: '#081249',
  color: '#fff',
};

export const addButton = {
  ...button,
  border: '2px dashed #A9C0F5',
  background: '#F5F8FF',
  color: '#1E3A8A',
  padding: '13px 18px',
  fontSize: '15px',
};

export const dangerButton = {
  ...button,
  border: '1px solid #FECACA',
  color: '#B91C1C',
  background: '#fff',
};

export const card = {
  border: '1px solid #E2E8F0',
  borderRadius: '12px',
  background: '#fff',
  padding: '18px',
  marginBottom: '14px',
};

export const cardHeader = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  marginBottom: '14px',
};

export const cardNumber = {
  fontSize: '15px',
  fontWeight: 700,
  color: '#0F172A',
};

export const warning = {
  display: 'inline-block',
  padding: '2px 10px',
  borderRadius: '999px',
  background: '#FEF3C7',
  color: '#92400E',
  fontSize: '12px',
  fontWeight: 600,
};
